// Use stored positive values first. Excerpts and headlines are not body estimates.
export function readableBody(body) {
  if (typeof body === "string") return body.replace(/<[^>]*>|[#*_`>]/g, " ");
  if (!Array.isArray(body)) return "";
  return body.map(block => {
    if (!block || typeof block !== "object" || ["image", "code"].includes(block.type)) return "";
    return [block.text, ...(Array.isArray(block.items) ? block.items : []),
      ...(Array.isArray(block.headers) ? block.headers : []), ...(Array.isArray(block.rows) ? block.rows.flat() : [])]
      .filter(value => typeof value === "string").join(" ");
  }).join(" ");
}
export function readingMinutes(article = {}) {
  if (!article || typeof article !== "object") return null;
  const value = article.read_time;
  const number = typeof value === "number" || (typeof value === "string" && value.trim()) ? Number(value) : NaN;
  if (Number.isFinite(number) && number > 0) return Math.ceil(number);
  const text = readableBody(article.body || article.body_markdown);
  const count = (text.match(/[\p{L}\p{N}]+(?:['’-][\p{L}\p{N}]+)*/gu) || []).length;
  return count ? Math.max(1, Math.ceil(count / 225)) : null;
}
export function readingTimeLabel(article, language = "en") {
  const minutes = readingMinutes(article);
  return minutes ? `${minutes} ${language === "id" ? "MENIT" : "MIN"}` : null;
}
